import { useTokenSelection } from '@/components/features/Account/AccountNFTList/useTokenSelection';
import { Box } from '@chakra-ui/react';
import { QuantityPicker } from '@sphere/ui';
import { rem } from 'polished';
import { ReactElement, cloneElement } from 'react';

type Props = {
  id: string;
  contractAddress: string;
  kind: 721 | 1155;
  tokensOwned: number;
  children: ReactElement;
  isEnabled?: boolean;
};

export const TokenSelectionWrapper = ({
  id,
  contractAddress,
  kind,
  tokensOwned,
  isEnabled,
  children,
}: Props) => {
  const [isSelecting, selectedToken, selectToken, removeToken] = useTokenSelection(state => [
    state.isSelecting,
    state.selectedTokens.find(token => token.id === id),
    state.selectToken,
    state.removeToken,
  ]);

  const isSelected = !!selectedToken;

  if (!isEnabled || !isSelecting) return children;

  const NFTCard = cloneElement(children, {
    pointerEvents: 'none',
    isActive: isSelected,
  });

  return (
    <Box pos="relative">
      <Box
        cursor="pointer"
        onClick={() =>
          isSelected
            ? removeToken({ id, contractAddress })
            : selectToken({ id, contractAddress, kind, quantity: 1 })
        }
        transition="opacity 0.2s"
        opacity={isSelected ? 1 : 0.5}
        _hover={{ opacity: isSelected ? 0.8 : 1 }}
      >
        {NFTCard}
      </Box>
      {isSelected && tokensOwned > 1 && (
        <Box pos="absolute" top="space.10" right="space.10" zIndex="in-front">
          <QuantityPicker
            value={selectedToken.quantity}
            onDebouncedChange={quantity => selectToken({ ...selectedToken, quantity })}
            onRemove={() => removeToken({ id, contractAddress })}
            max={tokensOwned}
            size={rem(36)}
            h={rem(40)}
            iconSize={rem(12)}
            textStyles={{ fontSize: 'sm' }}
            rounded="full"
          />
        </Box>
      )}
    </Box>
  );
};
